export type PlatformAccessLevel = 'none' | 'view' | 'edit';

export function hasPlatformVisibility(level: PlatformAccessLevel | undefined): boolean {
  return level === 'view' || level === 'edit';
}

export function hasPlatformEdit(level: PlatformAccessLevel | undefined): boolean {
  return level === 'edit';
}
